import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongSearchControlResetButton.module.scss";
import {useSongSearchControlResetButtonLogic} from "./SongSearchControlResetButton.logic";

export const SongSearchControlResetButton: VoidFunctionComponent = () => {
  const {isResetButtonAvailable, handleSearchInputReset} = useSongSearchControlResetButtonLogic();
  if (!isResetButtonAvailable) {
    // not available, don't return
    return null;
  }
  return (
    <button
      className={s.cancelSearchButton}
      onClick={handleSearchInputReset}
    >Cancel
    </button>
  );
}
